import { render } from "./ForumTopicDetail.vue?vue&type=template&id=1e1cee96&scoped=true"
import script from "./ForumTopicDetail.vue?vue&type=script&lang=js"
export * from "./ForumTopicDetail.vue?vue&type=script&lang=js"

import "./ForumTopicDetail.vue?vue&type=style&index=0&id=1e1cee96&lang=css"
import "./ForumTopicDetail.vue?vue&type=style&index=1&id=1e1cee96&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1cee96"]])

export default __exports__